import React from 'react';
import Lottie from "lottie-react";
import loadingAnimation from "src/assets/images/loading.json";

const AppLoading = props => {
	return (
		<>
			{props?.isLoading &&
				<div id="appLoading">
					<div className="loading-container text-black-color">
						<Lottie
							animationData={loadingAnimation}
							loop
							autoplay
							style={{ height: "150px", width: "300px", zIndex: "101" }}
						/>
						<span className='text-primary font-weight-bold text-center'>
							Cargando...
						</span>
					</div>
				</div>
			}
		</>
	);
};

export default AppLoading;